import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

export const NavArrow = ({ dir, onClick, className, testId }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={dir < 0 ? "Previous photo" : "Next photo"}
    className={cn("flex h-11 w-11 items-center justify-center rounded-md bg-white/95 text-ink shadow-md transition-[background-color,color] hover:bg-ink hover:text-white", className)}
    data-testid={testId}
  >
    {dir < 0 ? <ChevronLeft className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
  </button>
);
